export * from 'server/models/VesselServiceConfigure';


// WEBPACK FOOTER //
// ./data/models/VesselServiceConfigure.ts